import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye } from '@fortawesome/pro-solid-svg-icons/faEye'
import { Wrapper } from './styled'

interface IProps {
  attestationId: number
  count: number
  onOpen: (attestationId: number) => void
}

const AssociatedCoursesCell = ({ attestationId, count, onOpen }: IProps) => {
  const { t } = useTranslation()
  const prefix = 'administration.certificate.legalAttestationsList.table'

  if (!count) {
    return <>--</>
  }

  return (
    <Wrapper>
      <button type="button" onClick={() => onOpen(attestationId)}>
        {`${count} ${
          count === 1
            ? t(`${prefix}.associatedCourse`)
            : t(`${prefix}.associatedCoursesPlural`)
        }`}
        <FontAwesomeIcon icon={faEye} />
      </button>
    </Wrapper>
  )
}

export default AssociatedCoursesCell
